export enum SmtpEmailServerTypeEnum {
  RUNPLE = 'RUNPLE',
  EXTERNAL = 'EXTERNAL',
}
